import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../../_virtual/_rollupPluginBabelHelpers.js';

var LAST_SUCCESSFUL_ENDPOINT_KEY = 'failoverClient.lastSuccessfulEndpoint';
var NOT_FOUND = 404;
var BAD_GATEWAY = 502;
var SERVICE_UNAVAILABLE = 503;
var GATEWAY_TIMEOUT = 504;
var FAILOVER_STATUSES = [NOT_FOUND, BAD_GATEWAY, SERVICE_UNAVAILABLE, GATEWAY_TIMEOUT];
var defaultFailoverPolicy = function defaultFailoverPolicy(response) {
  var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return error || FAILOVER_STATUSES.includes(response.status);
};
var saveEndpoint = function saveEndpoint(endPoint) {
  localStorage.setItem(LAST_SUCCESSFUL_ENDPOINT_KEY, endPoint);
};
var failover = function failover(instances) {
  var lastSuccessfulEndpoint = localStorage.getItem(LAST_SUCCESSFUL_ENDPOINT_KEY) || '';
  var currentIndex = instances.findIndex(function (instance) {
    return instance === lastSuccessfulEndpoint;
  });
  if (currentIndex === -1) {
    currentIndex = 0;
    saveEndpoint(instances[currentIndex]);
  }
  var getCurrentInstance = function getCurrentInstance() {
    return instances[currentIndex];
  };
  var switchInstance = function switchInstance() {
    currentIndex = currentIndex + 1 > instances.length - 1 ? 0 : currentIndex + 1;
    saveEndpoint(instances[currentIndex]);
  };
  var withFailover = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(url, data) {
      var failoverPolicy,
        numberOfRetries,
        response,
        error,
        _args = arguments;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              failoverPolicy = _args.length > 2 && _args[2] !== undefined ? _args[2] : defaultFailoverPolicy;
              numberOfRetries = _args.length > 3 && _args[3] !== undefined ? _args[3] : instances.length - 1;
              _context.prev = 2;
              _context.next = 5;
              return fetch("".concat(getCurrentInstance()).concat(url), data);
            case 5:
              response = _context.sent;
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](2);
              error = _context.t0;
            case 11:
              if (!(failoverPolicy(response, error) && numberOfRetries > 0)) {
                _context.next = 14;
                break;
              }
              switchInstance();
              return _context.abrupt("return", withFailover(url, data, failoverPolicy, numberOfRetries - 1));
            case 14:
              if (!error) {
                _context.next = 16;
                break;
              }
              throw error;
            case 16:
              return _context.abrupt("return", response);
            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 8]]);
    }));
    return function withFailover(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  return withFailover;
};

export { FAILOVER_STATUSES, failover };
